// Angular
import { Component, ComponentFactoryResolver } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-suffix-cell-renderer',
	templateUrl: './suffix-cell.renderer.html',
	styleUrls: ['./suffix-cell.renderer.scss']
})
export class SuffixCellRenderer implements ICellRendererAngularComp {
	public suffix: string;
	public cellValue: any;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data[params['fieldName']];
		this.suffix = params['suffix'];
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
